<template>
    <div>

        <div class="player-filter scoring-filter">

            <div class="player-filter__top">

                <div class="wrapper">

                    <div class="player-filter__left">

                        <div class="player-filter__switch">
                            <ul>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="type = 'all'"
                                        :class="{ active: type == 'all' }"
                                        href="#">
                                        <span>all</span>
                                    </a>
                                </li>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="type = 'atp'"
                                        :class="{ active: type == 'atp' }"
                                        href="#">
                                        <span>atp</span>
                                    </a>
                                </li>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="type = 'wta'"
                                        :class="{ active: type == 'wta' }"
                                        href="#">
                                        <span>wta</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>

                    <div class="player-filter__right" ref="container" @mouseleave="handleMouseLeave">

                        <button  v-if="pdf_download"
                            class="general-button grey-blue generic-medium pdf_downloads"
                            @click="downloadClick"
                            ref="button">
                            <span v-html="ico_pdf"></span>
                            PDF downloads

                        </button>
                        <ul v-if="pdf_download" class="pdf_downloads__menu"
                            ref="menu"
                            @keydown="menuKeydown">
                            <li v-for="link in pdf_download">
                                <a :href="link.file" target="_blank">
                                    {{link.button_text}}
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>


            <div class="scoring-filter__separator"></div>

            <div class="player-filter__bottom">

                <div class="wrapper">

                    <div class="player-filter__type draws-rounds__mobile">
                        <label for="dayselector" class="vh">Day Selector</label>
                        <select ref="dayselector" id="dayselector" name="dayselector" v-model="selectedDay">
                            <option v-for="(day, dayIndex) in oop" :value="day.date">Day {{dayIndex+seq}} -
                                {{formatDate(day.date)}}
                            </option>
                        </select>
                    </div>

                    <div class="Draw-rounds" v-if="oop.length > 0">
                        <ul>
                            <li v-for="(day, dayIndex) in oop" :key="dayIndex">
                                <button class="general-button generic-medium scoring-round"
                                        :class="{ selected: selectedDay == day.date }"
                                        @click.prevent="selectedDay = day.date ">
                                    <span>Day {{dayIndex + 1}}</span>
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>

        </div>

        <div class="wrapper">

            <div v-if="oop.length > 0">
                <div v-for="day in dayOOP" class="OOP-day grid two">

                    <oop-court v-for="court in day.courts"
                               v-if="showCourtForType(court)"
                               :key="court.id"
                               :type="type"
                               :ticket="ticket"
                               :flagPath="flagPath"
                               :detail="detail"
                               :court="court">
                    </oop-court>

                </div>
            </div>

            <div class="na" v-else>
                <h2 class="na__title" style="margin-bottom: 0">
                    No matches for this day
                </h2>
            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment-timezone'
    import OOPCourt from './OOPCourt'
    import 'select2/dist/js/select2.full.js'
    import queryString from 'query-string'

    export default {
        components: {
            'oop-court': OOPCourt
        },
        props: ['flag', 'detail', 'ticket', 'pretype', 'pdf'],
        data() {
            return {
                oop             : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                selectedDay     : [],
                type            : this.pretype,
                oopMixed        : [],
                allMtch         : [],
                seq             : '',
                ico_pdf         : window.ico_pdf,
                pdf_download    : JSON.parse(this.pdf),
                showDownloads   : false,
            }
        },
        created() {

            // set the currently selected day based on query parameters;
            // technically, this doesn't change in the getFeed function below if already set
            const parsedQuery = queryString.parse( location.search )

            if( parsedQuery && parsedQuery.selected_day ){
                this.selectedDay = parsedQuery.selected_day

                // clean the URL
                window.history.pushState({}, document.title, location.pathname )
            }

            this.getFeed()
        },
        watch: {
            type() {
                this.getFeed()

            }
        },
        computed: {
            dayOOP() {
                return this.oop.filter(days => days.date == this.selectedDay)
            }
        },
        mounted() {
            let app = this
            jQuery('#dayselector').select2({
                width: '100%'
            }).on('change', function () {
                app.selectedDay = this.value
            })
             document.addEventListener('click', this.outsideClick);
        },

        beforeDestroy() {
            document.removeEventListener('click', this.outsideClick);
        },
        methods: {
            getFeed() {
                let url = `${window.feed_ip}/get/${this.type}/${window.tournament}/oop`


                axios.get( url ).then(response => {

                    this.allMtch = response.data

                    if( this.type != 'all' ) {
                        this.oop = this.filterMatchesByType( response.data, this.type )

                        let totalDaysCount = response.data.length

                        if ( totalDaysCount ) {
                            this.seq = parseInt(response.data[0].seq)

                            let today   = moment().tz('America/New_York').startOf('day').format('YYYY-MM-DD')
                            let nowTime = moment().tz('America/New_York').format('HH')

                            if ( this.selectedDay.length < 1 ) {
                                if ( nowTime >= 20 ){
                                    this.selectedDay = response.data[totalDaysCount - 1].date
                                }else{
                                    this.selectedDay = today
                                }
                            }

                            //this.loading = false
                        }
                    }

                }).catch(function (error) {
                    console.log(error)
                })

                // Mixed OOP
                axios.get(`${window.feed_ip}/get/${window.tournament}/oop-mixed`).then(response => {

                    this.oopMixed = response.data

                    if( this.type == 'all' ){
                        this.oop = this.oopMixed

                        let totalDaysCount = response.data.length

                        if ( totalDaysCount ) {
                            this.seq = parseInt(response.data[0].seq)

                            if ( this.selectedDay.length < 1 ) {

                                let today = moment().tz('America/New_York').startOf('day').format('YYYY-MM-DD')
                                let nowTime = moment().tz('America/New_York').format('HH')

                                if ( nowTime >= 20 ){
                                    this.selectedDay = response.data[totalDaysCount - 1].date
                                }else{
                                    this.selectedDay = today
                                }
                            }

                            //this.loading = false
                        }
                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            formatDate(date) {
                return moment(date).format('MMMM DD')
            },
            showCourtForType(court) {

                if (this.type == 'all') {
                    return true
                }

                let possibleMatches = court.matches.filter(match => match.type == this.type)

                if (possibleMatches.length == 0) {
                    return false
                }

                return true
            },
            getAllMatchesInOneArray(days) {
                let allMatches = []

                for (let day of days) {
                    for (let court of day.courts) {
                        allMatches.push(...court.matches)
                    }
                }

                return allMatches
            },
            filterMatchesByType(days, type) {
                let app = this

                days.forEach( function( day, i ) {
                    day.courts.forEach( function ( court, j ) {
                        day.courts[j].matches = court.matches.filter( function( match ) {
                            if ( match.type == type )
                                return true
                        })
                    })
                })

                return days
            },
            downloadClick(event) {
                let thisEl = jQuery(event.target),
                parentEl = thisEl.parent();


                if (parentEl.hasClass('open')) {
                    parentEl.removeClass('open').next().slideUp();
                } else {
                    jQuery('.drawer__nav .open').removeClass('open').next().slideUp();
                    parentEl.addClass('open').next().slideDown(() => {
                        parentEl.next().find('a:first').focus(); // Set focus on the first menu item
                    });
                }

                event.preventDefault(); // Prevent any default behavior
            },

            menuKeydown(event) {
                if (event.keyCode === 9 && event.shiftKey) { // Shift + Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[0]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                } else if (event.keyCode === 9 && !event.shiftKey) { // Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[menuItems.length - 1]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                }
            },

            outsideClick(event) {
                const container = jQuery(this.$refs.container);
                if (!container.is(event.target) && !container.has(event.target).length) {
                    container.removeClass('open').find('.pdf_downloads__menu').slideUp();
                }
            },
            handleMouseLeave() {
                const container = jQuery(this.$refs.container)
                container.removeClass('open').find('.pdf_downloads__menu').slideUp();
            }
        }
    }
</script>
